import PropTypes from 'prop-types';
import React from 'react';
import { List } from 'immutable';
import classNames from 'classnames';
import { Secret } from '../../stores/SecretStore';
import withEditMode from '../../components/hocs/withEditMode.react';
import { ResourceSelect, SecretKeyInput, SecretValueInput, SecretNameInput, EditCredentialActionButtons } from './EditCredentialComponents.react';

const EditCredentialForm = (
  { addTopBorder, resources, currentEditedCredential, editFromFormField, exitEditMode },
) => (
  <div className={classNames({ 'credential-listing': true, 'credential-listing-border-top': addTopBorder })}>
    <div className='credential-leftside'>
      <ResourceSelect
        credential={currentEditedCredential}
        resources={resources}
        onResourceChange={editFromFormField('resourceId')}
      />
      <SecretKeyInput
        credential={currentEditedCredential}
        onUpdateSecretKey={editFromFormField('secretKey')}
      />
      <SecretValueInput
        credential={currentEditedCredential}
        onUpdateSecretValue={editFromFormField('secretValue')}
      />
      <SecretNameInput
        credential={currentEditedCredential}
        onUpdateSecretName={editFromFormField('secretName')}
      />
    </div>
    <EditCredentialActionButtons
      credential={currentEditedCredential}
      exitEditMode={exitEditMode}
    />
  </div>
);

EditCredentialForm.propTypes = {
  addTopBorder: PropTypes.bool,
  resources: PropTypes.instanceOf(List),
  currentEditedCredential: PropTypes.instanceOf(Secret),
  editFromFormField: PropTypes.func,
  exitEditMode: PropTypes.func,
};

export default withEditMode('credential')(EditCredentialForm);
